<template>
    <div class="container">
        <div class="image-container" @click="go">
            <div>
                <img :src="img" class="img" :class="{'expired':expired}" height="200">
            </div>
        </div>
        <div class="body">
            <div style="display: flow-root">
                <div class="title" align="left">
                    {{name}}
                </div>
                <div class="types" align="left">
                    <span v-for="type in types" :key="type.id" :style="getStyle(type)">
                        {{type.name}}
                    </span>
                </div>
            </div>
            <div class="desc">
                <div class="outer">
                    <div class="middle">
                        <div class="inner" align="left">
                            {{desc}} 
                        </div>
                    </div>
                </div>
            </div>
            <div class="prize-title" align="left">
                <span v-if="expired">{{prizeEndTitle}}:</span>
                <span v-else>{{prizeTitle}}:</span>
            </div>
            <div class="prize">
                <div class="outer">
                    <div class="middle">
                        <div class="inner" align="left">
                            <span v-if="prizes != undefined && prizes.length > 0">
                                <div v-for="(p, index) in prizes" :key="index" class="prize-list">
                                    <b>{{p.title}}: </b>
                                    {{p.desc}}
                                </div>
                            </span>
                            <span v-else>
                                {{prize}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="go-button" @click="go">
                <div class="outer" style="height: 140px">
                    <div class="middle">
                        <div class="inner" align="center">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="date" align="right">
                    Creado el {{creationDate}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContestCard',
    props: {
        id: Number,
        name: String,
        img: {
            type: String,
            default: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png'
        },
        desc: String,
        prizeTitle: String,
        prizeEndTitle: String,
        prize: String,
        prizes: Array,
        creationDate: String,
        expired: {
            type: Boolean,
            default: false
        },
        types: Array
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    mounted(){
        /*document.addEventListener("scroll", (e) => {
            this.anim = (e.srcElement.documentElement.scrollTop > 10);
        })*/
    },
    methods: {
        getStyle(type){
            var obj = {};
            if(type.color != undefined && type.color != "") obj.color = type.color;
            return obj;
        },
        load(){
            this.full = true;
        },
        go(){
            this.$emit('click', this.id);
        }
    },
    computed: {
    },
}
</script>


<style scoped>

    .container {
        height: 200px;
        width: 100%;

    }

    .container > div {
        background-color: #222933CC;
        border-color: gray;
        border-left: solid 1px;
        border-right: solid 1px;
        border-top: solid 1px;
        border-bottom: solid 1px;
    }

	.image-container {
        height: 200px;
        width: 200px;
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
        border-right: none !important;
        
        float: left;
    }

    .image-container > div {
        height: 200px;
        width: 200px;
        border-radius: 50%;
        transform: scale(1);
        transition: border-bottom-right-radius .4s ease-in-out;
        overflow: hidden;
        cursor: pointer;
    }

    .image-container > div > img {
        transform: scale(1);
        transition: transform .4s ease-in-out;
    }

    .image-container > div:hover {
        border-bottom-right-radius: 0%;
    }

    .image-container > div:hover > img {
        transform: scale(1.1);
    }

    .img {

    }

    .img.expired {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }

    .body {
        height: 200px;
        width: calc(100% - 222px);
        border-left: none !important;
        float: left;

        
        position: relative;

        padding-left: 20px;
    }

    .body .title {
        float: left;
        text-transform: uppercase;
        letter-spacing: 3px;
        font-weight: lighter;
        line-height: 50px;
        font-size: 20px;
        position: relative;
        left: -30px;
        color: #ffd777;
    }

    .types {
        float: right;
        text-transform: uppercase;
        font-weight: bolder;
        font-size: 10px;
        padding: 10px;
    }

    .types>span:nth-child(1):before {
        content: "";
        border-left: none !important;
        padding-right: 3px;
    }

    .types>span:nth-child(n+1):before {
        content: "";
        border-left: 1px solid #DDD;
        padding-right: 3px;
    }

    .outer {
        display: table;
        height: 30px;
        width: 100%;
    }

    .middle {
        display: table-cell;
        vertical-align: middle;
    }

    .inner {
        margin-left: auto;
        line-height: 36px;
    }

    .desc {
        position: relative;
        top: -10px;
        left: -10px;
    }

    .desc .outer .middle .inner {
        padding-right: 30px;
    }

    .prize-title {
        position: relative;
        top: -5px;
        text-transform: uppercase;
        letter-spacing: 2px;
        font-weight: lighter;
        line-height: 20px;
        font-size: 12px;
        margin-right: 5px;
        color: #e45e10;
    }

    .prize {
        position: relative;
        left: 10px;
        font-size: 13px;
    }

    .prize-list {
        font-size: 13px;
        line-height: 9px;
        padding-top: 10px;
    }

    .footer {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    .date {
        font-size: 10px;
        padding: 5px;
        color: gray;
    }

    .go-button {
        position: absolute;
        right: 0px;
        width: 40px;
        top: 30px;
        bottom: 30px;
        box-shadow: 0px 0px 0px 0px #222933CC;
        transition: background-color .4s ease-in-out, box-shadow .6s ease-in-out, width .2s ease-in-out;
    }

    .go-button:hover {
        cursor: pointer;
        width: 35px;
        background-color: #222933CC;
        box-shadow: -6px 0px 7px 2px #222933CC;
    }
</style>